(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom_2o3_anchor"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.SLAnchor) return;
    window.SLAnchor = true;
    let cancelAlignment = () => {};

    // Keep native hash history/focus. Correct only layout drift after scrolling settles,
    // with a bounded window that stops immediately when the visitor takes control.
    function alignHash() {
      cancelAlignment();
      if (window.Shopify?.designMode) return;
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const anchor = document.getElementById(id);
      if (!anchor?.matches('.sl-anchor')) return;

      const started = performance.now();
      let stableSince = started;
      let lastTop = anchor.getBoundingClientRect().top + scrollY;
      let lastScroll = scrollY;
      let corrections = 0;
      let frame;
      const events = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
      function cancel() {
        cancelAnimationFrame(frame);
        events.forEach(type => window.removeEventListener(type, cancel));
      }
      cancelAlignment = cancel;
      events.forEach(type => window.addEventListener(type, cancel, { passive: true }));

      function settle(now) {
        if (!anchor.isConnected || now - started > 4000) return cancel();
        const rect = anchor.getBoundingClientRect();
        const top = rect.top + scrollY;
        if (Math.abs(top - lastTop) > 1 || Math.abs(scrollY - lastScroll) > 1) stableSince = now;
        lastTop = top;
        lastScroll = scrollY;
        if (now - started >= 600 && now - stableSince >= 250) {
          const margin = parseFloat(getComputedStyle(anchor).scrollMarginTop) || 0;
          const maxScroll = document.documentElement.scrollHeight - innerHeight;
          const destination = Math.max(0, Math.min(maxScroll, top - margin));
          if (Math.abs(destination - scrollY) <= 2 || corrections >= 2) return cancel();
          scrollTo({
            top: destination,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
          corrections += 1;
          lastScroll = scrollY;
          stableSince = now;
        }
        frame = requestAnimationFrame(settle);
      }
      frame = requestAnimationFrame(settle);
    }

    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash) {
        setTimeout(alignHash, 0);
      }
    });
    window.addEventListener('hashchange', alignHash);
    window.addEventListener('pagehide', () => cancelAlignment());
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alignHash, { once: true });
    else alignHash();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom_2o3_text"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__c2o3TextInit) return;
    window.__c2o3TextInit = true;

    var FONT = {
      sans: 'var(--font-sans)',
      serif: 'var(--font-serif)',
      'serif-cond': 'var(--font-serif-cond)',
      'serif-extra': 'var(--font-serif-extra)',
      display: 'var(--font-display)',
      mono: 'var(--font-mono)'
    };
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var motionControllers = new Set();
    var motionObserver = null;
    var fontsSettled = !document.fonts || !document.fonts.ready;

    function transparent(color) {
      return !color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)' || color === 'rgba(0,0,0,0)' || color === '#00000000';
    }

    function tokensFromNode(node) {
      if (!node || node.nodeType !== 1) return [];
      if (node.classList.contains('c2o3-text-token')) return [node];
      return Array.prototype.slice.call(node.querySelectorAll('.c2o3-text-token')).filter(function (token) {
        return !token.closest('[data-c2o3-text]');
      });
    }

    function walkAdjacent(host, dir) {
      var tokens = [];
      var node = dir === 'prev' ? host.previousElementSibling : host.nextElementSibling;
      while (node) {
        if (node.matches('[data-c2o3-text]') || node.querySelector('[data-c2o3-text]')) break;
        var found = tokensFromNode(node);
        if (found.length) {
          tokens = tokens.concat(found);
          node = dir === 'prev' ? node.previousElementSibling : node.nextElementSibling;
          continue;
        }
        var empty = !node.textContent || !node.textContent.trim();
        if (empty || node.hasAttribute('hidden')) {
          node = dir === 'prev' ? node.previousElementSibling : node.nextElementSibling;
          continue;
        }
        break;
      }
      return tokens;
    }

    function collectTokens(container) {
      var nested = Array.prototype.slice.call(container.querySelectorAll('.c2o3-text-token'));
      var prev = walkAdjacent(container, 'prev');
      var next = walkAdjacent(container, 'next');
      var wrap = container.parentElement;
      if (wrap && wrap !== document.body) {
        prev = prev.concat(walkAdjacent(wrap, 'prev'));
        next = next.concat(walkAdjacent(wrap, 'next'));
      }
      return nested.concat(prev, next);
    }

    function strip(container) {
      container.querySelectorAll('.c2o3-text__hl').forEach(function (span) {
        span.replaceWith(document.createTextNode(span.textContent));
      });
    }

    function textNodes(root) {
      var nodes = [];
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          var parent = node.parentElement;
          if (!parent || parent.closest('.c2o3-text-token')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      while (walker.nextNode()) nodes.push(walker.currentNode);
      return nodes;
    }

    function preserveLabel(el) {
      el.__c2o3OriginalLabel = el.getAttribute('aria-label');
      el.setAttribute('aria-label', el.textContent.trim());
    }

    function restoreLabel(el) {
      if (el.__c2o3OriginalLabel === null) el.removeAttribute('aria-label');
      else if (typeof el.__c2o3OriginalLabel === 'string') el.setAttribute('aria-label', el.__c2o3OriginalLabel);
      delete el.__c2o3OriginalLabel;
    }

    function splitWords(el) {
      var units = [];
      preserveLabel(el);
      textNodes(el).forEach(function (node) {
        var fragment = document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part || /^\s+$/.test(part)) {
            fragment.appendChild(document.createTextNode(part));
            return;
          }
          var mask = document.createElement('span');
          var unit = document.createElement('span');
          mask.className = 'c2o3-motion__mask';
          mask.setAttribute('aria-hidden', 'true');
          unit.className = 'c2o3-motion__unit';
          unit.textContent = part;
          mask.appendChild(unit);
          fragment.appendChild(mask);
          units.push(unit);
        });
        node.replaceWith(fragment);
      });
      return units;
    }

    function splitCharacters(el) {
      var units = [];
      preserveLabel(el);
      textNodes(el).forEach(function (node) {
        var fragment = document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part || /^\s+$/.test(part)) {
            fragment.appendChild(document.createTextNode(part));
            return;
          }
          var word = document.createElement('span');
          word.className = 'c2o3-motion__type-word';
          word.setAttribute('aria-hidden', 'true');
          Array.from(part).forEach(function (character) {
            var unit = document.createElement('span');
            unit.className = 'c2o3-motion__char';
            unit.textContent = character;
            word.appendChild(unit);
            units.push(unit);
          });
          fragment.appendChild(word);
        });
        node.replaceWith(fragment);
      });
      return units;
    }

    function unwrapMotion(el) {
      el.querySelectorAll('.c2o3-motion__mask, .c2o3-motion__type-word').forEach(function (wrapper) {
        wrapper.replaceWith(document.createTextNode(wrapper.textContent));
      });
      restoreLabel(el);
      el.normalize();
    }

    function pausedAnimation(node, keyframes, options) {
      var animation = node.animate(keyframes, options);
      animation.pause();
      animation.currentTime = 0;
      return animation;
    }

    function numberAttribute(container, name, fallback) {
      var value = parseInt(container.getAttribute(name), 10);
      return Number.isNaN(value) ? fallback : value;
    }

    function finishMotion(controller) {
      if (controller.finished) return;
      controller.finished = true;
      if (motionObserver) motionObserver.unobserve(controller.container);
      controller.animations.forEach(function (animation) { animation.cancel(); });
      controller.container.removeAttribute('data-c2o3-typing');
      if (controller.split) unwrapMotion(controller.el);
      controller.container.setAttribute('data-c2o3-motion-complete', '');
      motionControllers.delete(controller);
    }

    function playMotion(controller) {
      if (controller.played || controller.finished) return;
      controller.played = true;
      controller.animations.forEach(function (animation) { animation.play(); });
      Promise.all(controller.animations.map(function (animation) {
        return animation.finished.catch(function () {});
      })).then(function () { finishMotion(controller); });
    }

    function getMotionObserver() {
      if (motionObserver || !('IntersectionObserver' in window)) return motionObserver;
      motionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          motionControllers.forEach(function (controller) {
            if (controller.container === entry.target) playMotion(controller);
          });
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      return motionObserver;
    }

    function initMotion(container) {
      if (container.hasAttribute('data-c2o3-motion-initialized')) return;
      container.setAttribute('data-c2o3-motion-initialized', '');

      var effect = container.getAttribute('data-c2o3-motion') || 'inherit';
      var el = container.querySelector('.c2o3-text__el');
      if (!el || effect === 'inherit' || effect === 'none' || motionQuery.matches) {
        container.setAttribute('data-c2o3-motion-complete', '');
        return;
      }

      var duration = numberAttribute(container, 'data-motion-duration', 900);
      var delay = numberAttribute(container, 'data-motion-delay', 0);
      var stagger = numberAttribute(container, 'data-motion-stagger', 50);
      var distance = numberAttribute(container, 'data-motion-distance', 24);
      var blur = Math.min(16, numberAttribute(container, 'data-motion-blur', 8));
      var typeSpeed = numberAttribute(container, 'data-motion-type-speed', 45);
      var easing = 'cubic-bezier(0.16, 1, 0.3, 1)';
      var animations = [];
      var split = false;

      if (effect === 'word-reveal') {
        split = true;
        splitWords(el).forEach(function (unit, index) {
          animations.push(pausedAnimation(unit,
            [{ opacity: 0, transform: 'translateY(' + distance + 'px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: duration, delay: delay + index * stagger, easing: easing, fill: 'both' }
          ));
        });
      } else if (effect === 'typewriter') {
        split = true;
        var typeUnits = splitCharacters(el);
        var showCursor = container.hasAttribute('data-motion-type-cursor');
        if (showCursor) container.setAttribute('data-c2o3-typing', '');
        typeUnits.forEach(function (unit, index) {
          var animation = pausedAnimation(unit,
            [{ opacity: 0 }, { opacity: 0, offset: 0.95 }, { opacity: 1 }],
            { duration: Math.max(16, typeSpeed * 0.25), delay: delay + index * typeSpeed, easing: 'linear', fill: 'both' }
          );
          if (showCursor) {
            animation.finished.then(function () {
              typeUnits.forEach(function (character) { character.classList.remove('c2o3-motion__cursor'); });
              unit.classList.add('c2o3-motion__cursor');
            }).catch(function () {});
          }
          animations.push(animation);
        });
      } else if (effect === 'mask-up' || effect === 'mask-down') {
        var direction = effect === 'mask-up' ? 105 : -105;
        animations.push(pausedAnimation(el,
          [{ transform: 'translateY(' + direction + '%)' }, { transform: 'translateY(0)' }],
          { duration: duration, delay: delay, easing: easing, fill: 'both' }
        ));
      } else if (effect === 'blur-reveal') {
        animations.push(pausedAnimation(el,
          [{ opacity: 0, filter: 'blur(' + blur + 'px)', transform: 'translateY(' + distance + 'px)' }, { opacity: 1, filter: 'blur(0)', transform: 'translateY(0)' }],
          { duration: duration, delay: delay, easing: easing, fill: 'both' }
        ));
      } else {
        animations.push(pausedAnimation(el,
          [{ opacity: 0, transform: 'translateY(' + distance + 'px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: duration, delay: delay, easing: easing, fill: 'both' }
        ));
      }

      if (!animations.length) {
        container.setAttribute('data-c2o3-motion-complete', '');
        return;
      }

      var controller = { container: container, el: el, animations: animations, split: split, played: false, finished: false };
      motionControllers.add(controller);
      var observer = getMotionObserver();
      if (observer) observer.observe(container);
      else playMotion(controller);
    }

    function applyToken(el, token) {
      var target = token.getAttribute('data-target');
      if (!target || el.innerHTML.indexOf(target) === -1) return;

      var fontKey = token.getAttribute('data-font') || 'inherit';
      var size = parseInt(token.getAttribute('data-size'), 10) || 0;
      var sizeM = parseFloat(token.getAttribute('data-size-mobile')) || 0;
      var leading = parseFloat(token.getAttribute('data-leading')) || 0;
      var leadingM = parseFloat(token.getAttribute('data-leading-mobile')) || 0;
      var weight = parseInt(token.getAttribute('data-weight'), 10) || 0;
      var tracking = parseInt(token.getAttribute('data-tracking'), 10) || 0;
      var color = token.getAttribute('data-color') || '';

      var span = document.createElement('span');
      span.className = 'c2o3-text__hl';
      if (token.getAttribute('data-break-line') === 'true') span.classList.add('c2o3-text__hl--break-desktop');
      if (token.getAttribute('data-break-line-mobile') === 'true') span.classList.add('c2o3-text__hl--break-mobile');
      if (fontKey === 'display') span.classList.add('c2o3-text__hl--agharti');
      if (FONT[fontKey]) span.style.fontFamily = FONT[fontKey];
      if (size > 0) span.style.setProperty('--c2o3-hl-size', size + 'px');
      if (sizeM > 0) span.style.setProperty('--c2o3-hl-size-mobile', sizeM + 'px');
      if (leading > 0) span.style.setProperty('--c2o3-hl-leading', String(leading));
      if (leadingM > 0) span.style.setProperty('--c2o3-hl-leading-mobile', String(leadingM));
      if (fontKey === 'display') {
        span.style.fontWeight = '700';
        span.style.letterSpacing = '0';
      } else {
        if (weight > 0) span.style.fontWeight = String(weight);
        if (tracking !== 0) span.style.letterSpacing = tracking / 1000 + 'em';
      }
      if (fontKey === 'serif-extra' || token.getAttribute('data-italic') === 'true') {
        span.style.fontStyle = 'italic';
      }
      if (token.getAttribute('data-uppercase') === 'true') {
        span.style.textTransform = 'uppercase';
      }
      if (!transparent(color)) span.style.color = color;
      span.textContent = target;

      el.innerHTML = el.innerHTML.split(target).join(span.outerHTML);
    }

    function applyOne(container, withMotion) {
      strip(container);
      var el = container.querySelector('.c2o3-text__el');
      if (!el) return;
      collectTokens(container).forEach(function (token) {
        applyToken(el, token);
      });
      if (withMotion) initMotion(container);
    }

    function applyScope(scope, withMotion) {
      var containers = [];
      if (scope.matches && scope.matches('[data-c2o3-text]')) containers.push(scope);
      if (scope.querySelectorAll) containers = containers.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-c2o3-text]')));
      containers.forEach(function (container) { applyOne(container, withMotion); });
    }

    applyScope(document, fontsSettled);
    document.addEventListener('shopify:section:load', function (event) {
      applyScope(event.target, fontsSettled);
    });
    document.addEventListener('product-info:loaded', function (event) {
      applyScope(event.target, fontsSettled);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      motionControllers.forEach(function (controller) {
        if (event.target.contains(controller.container)) finishMotion(controller);
      });
    });
    motionQuery.addEventListener('change', function () {
      if (motionQuery.matches) motionControllers.forEach(finishMotion);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fontsSettled = true;
        applyScope(document, true);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
